<template>
    <div class="contact-form">
        <h3>BBE <br> is here to help you</h3>
        <p>Do you have a question about our banking solutions? Would you like to know more about our product range? Contact us today.</p>

        <TransitionGroup name="form">
        <div class="field-wrapper" v-show="currentStep==0" key="0">
            <label for="firstname">First name</label>
            <input placeholder="ex. John" class="form-field" type="text" id="firstname" v-model="form.firstname">
            <div v-if="error||$page.props.errors.firstname" class="field-error">{{ error || $page.props.errors.firstname }}</div>
        </div>

        <div class="field-wrapper" v-show="currentStep==1" key="1">
            <label for="lastname">Last name</label>
            <input placeholder="ex. Dupont" class="form-field" id="lastname" type="text" v-model="form.lastname">
            <div v-if="error||$page.props.errors.lastname" class="field-error">{{ error || $page.props.errors.lastname }}</div>
        </div>

        <div class="field-wrapper" v-show="currentStep==2" key="2">
            <label for="phone">Phone number</label>
            <input placeholder="Mobile or fixed line" class="form-field" type="text" id="phone" v-model="form.phone">
            <div v-if="error||$page.props.errors.phone" class="field-error">{{ error || $page.props.errors.phone }}</div>
        </div>

        <div class="field-wrapper" v-show="currentStep==3" key="3">
            <label for="email">Email</label>
            <input class="form-field" type="text" id="email" v-model="form.email">
            <div v-if="error||$page.props.errors.email" class="field-error">{{ error || $page.props.errors.email }}</div>
        </div>

        <div class="field-wrapper" v-show="currentStep==4" key="4">
            <label for="subject">Subject</label>
            <select class="form-field" id="subject" v-model="form.subject">
                <option value="Account Opening">Account Opening</option>
                <option value="Question about a product">Question about a product</option>
                <option value="General info">General info</option>
                <option value="Other">Other</option>
            </select>
            <div v-if="error||$page.props.errors.subject" class="field-error">{{ error || $page.props.errors.subject }}</div>
        </div>

        <div class="field-wrapper" v-show="currentStep==5" key="5">
            <label for="message">Your message</label>
            <textarea placeholder="" class="form-field" id="message" v-model="form.message"></textarea>
            <div v-if="error||$page.props.errors.message" class="field-error">{{ error || $page.props.errors.message }}</div>
        </div>
        </TransitionGroup>

        <button class="form-button button-black" @click.prevent="send">
            <span v-if="currentStep<6">Validate {{ currentStep+1 }}/6</span>
            <span v-else>Send</span>
        </button>
    </div>
</template>

<script>
export default {
    props: ['page', 'branche'],
    data() {
        return {
            error: null,
            currentStep: 0,
            can_send: true,
            mail_to: null,
            form: {
                firstname: null,
                lastname: null,
                phone: null,
                email: null,
                subject: null,
                message: null,
                type: 'contact',
                lang: this.$page.props.current_locale,
            },
        }
    },
    computed:{
        formSteps(){
            return _.keys(this.form)
        },
        currentStepName(){
            return this.formSteps[this.currentStep]
        },
        dataToSend(){
            return _.pick(this.form, this.currentStepName)
        },
    },
    watch: {
        branche(newVal, oldVal) {
            this.mail_to = newVal;
        }
    },
    methods: {
        send() {
            this.error = null;
            axios.post(
                this.$route('app.contact_check'),
                this.dataToSend
            ).then(() => {
                console.log(this.dataToSend)
                if (this.currentStep == 5) {
                    if (this.can_send) {
                        this.can_send = false;
                        this.$inertia.post(this.$route('app.contact.store'),
                            this.form,
                            {
                                preserveScroll: true,
                                preserveState: true,
                                onFinish: () => {
                                    this.can_send = true;
                                }
                            }
                        )
                    }
                } else {
                    this.currentStep++;
                }
            }).catch(({response}) => {
                this.error = response.data.errors[this.currentStepName][0]
            })

        }
    }
}
</script>

<style scoped>
.form-enter-active,
.form-leave-active {
    transition: all 0.5s ease;
}
.form-enter-from{
    position: absolute;
    top:0;
    opacity: 0;
    transform: translateX(-50%);
}
.form-leave-to {
    position: absolute;
    top:0;
    opacity: 0;
    transform: translateX(50%);
}
</style>
